export default __webpack_public_path__ + "static/media/oman.7133dfa0.svg";